import "./Footer.css";
import cta from "../../../assets/Images/cta-bg.png";
import { useEffect, useRef, useState } from "react";

const Footer = () => {
  const newsletterRef = useRef(null);
  const footerRef = useRef(null);
  const [subscribed, setSubscribed] = useState(false);
  const [email, setEmail] = useState("");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target
              .querySelectorAll(".footer-animate")
              .forEach((el, i) => {
                setTimeout(() => el.classList.add("footer-animated"), i * 120);
              });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (newsletterRef.current) observer.observe(newsletterRef.current);
    if (footerRef.current) observer.observe(footerRef.current);
    return () => observer.disconnect();
  }, []);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email.trim()) {
      setSubscribed(true);
      setEmail("");
      setTimeout(() => setSubscribed(false), 4000);
    }
  };

  return (
    <div className="footer-tag">

      {/* ── Newsletter Banner ── */}
      <div className="newsletter-section" ref={newsletterRef}>
        {/* Decorative blobs */}
        <div className="nl-blob nl-blob-1" />
        <div className="nl-blob nl-blob-2" />
        <div className="nl-blob nl-blob-3" />

        {/* Wave bottom */}
        <svg className="nl-wave" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 80" preserveAspectRatio="none">
          <path fill="#081B2E" d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" />
        </svg>

        <div className="nl-inner">
          {/* Left – image */}
          <div className="nl-image-wrap footer-animate">
            <div className="nl-image-ring" />
            <img src={cta} alt="newsletter" className="nl-image" />
          </div>

          {/* Right – content */}
          <div className="nl-content footer-animate">
            <span className="nl-badge">📬 Stay in the loop</span>
            <h2 className="nl-title">
              Subscribe to our newsletter<br />
              <span>and stay updated</span>
            </h2>
            <p className="nl-sub">
              Get the latest HR insights, product updates, and industry news
              delivered straight to your inbox. No spam, ever.
            </p>

            {subscribed ? (
              <div className="nl-success">
                <span className="nl-success-icon">✓</span>
                Thanks for subscribing! We'll be in touch soon.
              </div>
            ) : (
              <form className="nl-form" onSubmit={handleSubscribe}>
                <div className="nl-input-wrap">
                  <svg className="nl-mail-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    className="nl-input"
                    required
                  />
                </div>
                <button type="submit" className="nl-btn">
                  Subscribe
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <line x1="5" y1="12" x2="19" y2="12"/>
                    <polyline points="12,5 19,12 12,19"/>
                  </svg>
                </button>
              </form>
            )}

            <p className="nl-privacy">🔒 We respect your privacy. Unsubscribe anytime.</p>
          </div>
        </div>
      </div>

      {/* ── Main Footer ── */}
      <footer className="main-footer" ref={footerRef}>
        <div className="footer-inner">

          {/* Brand */}
          <div className="footer-brand footer-animate">
            <div className="footer-logo-text">Seekk</div>
            <p>
              The best platform to hire the right candidates and manage your
              entire workforce. Trusted by 1500+ companies across 65+ countries.
            </p>
            <div className="footer-socials">
              <a href="#" className="social-icon" aria-label="LinkedIn">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
              </a>
              <a href="#" className="social-icon" aria-label="Twitter">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/></svg>
              </a>
              <a href="#" className="social-icon" aria-label="Facebook">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
              </a>
            </div>
          </div>

          {/* Product */}
          <div className="footer-col footer-animate">
            <h3>Product</h3>
            <ul>
              <li><a href="#">HRMS</a></li>
              <li><a href="#">Payroll</a></li>
              <li><a href="#">Recruitment</a></li>
              <li><a href="#">ESS Portal</a></li>
              <li><a href="#">Performance</a></li>
            </ul>
          </div>

          {/* Company */}
          <div className="footer-col footer-animate">
            <h3>Company</h3>
            <ul>
              <li><a href="#">About Us</a></li>
              <li><a href="#">Careers</a></li>
              <li><a href="#">Blog</a></li>
              <li><a href="#">Press</a></li>
              <li><a href="#">Contact Us</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="footer-col footer-animate">
            <h3>Legal</h3>
            <ul>
              <li><a href="#">Terms & Conditions</a></li>
              <li><a href="#">Privacy Policy</a></li>
              <li><a href="#">Cookie Policy</a></li>
              <li><a href="#">Security</a></li>
            </ul>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <span>© 2025 Seekk. All rights reserved.</span>
          <span>Made with ❤️ for HR teams worldwide</span>
        </div>
      </footer>

    </div>
  );
};

export default Footer;
